import { useCallback, useEffect, useState, useRef } from 'react';
import { ROUTE_SECURITY_LETTERS, ROUTE_WELCOME } from '../../routes/Routes';
import { useNavigate } from "react-router-dom";
import usePageTitle from '../../hooks/usePageTitle';
import GetFetch from '../../hooks/GetFetch';
import { LoadingPanel } from "../../components/LoadingPanel";
import GetFetchZip from '../../hooks/GetFetchZip';
import { Button, SelectBox } from "devextreme-react";
import DataGrid, {
    Column,
    Format,
    Item,
    KeyboardNavigation,
    Pager,
    Paging,
    SearchPanel,
    GroupItem,
    Summary,
    Toolbar
} from 'devextreme-react/data-grid';
import CustomPreparedHeaderCell from '../../components/CustomPreparedHeaderCell';
import { allowedPageSizes, pageFormats } from '../../components/GlobalDataGridConfigurations';
import { logExport, useAuth } from '../../hooks/useAuth';
import ExportGrid from '../../components/ExportGrid';
import './ListLetters.scss';


const BasicSecurityData = () => {
    const { title } = ROUTE_SECURITY_LETTERS;
    const { user } = useAuth();
    const email = user.email.toString().toLowerCase();
    const navigate = useNavigate();
    const navigateToHomePage = () => navigate(ROUTE_WELCOME.withSlash);
    const dataGridRef = useRef(null);
    const [allowCreate, setAllowCreate] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState();
    const [allAgencies, setAllAgencies] = useState([]);  
    const [allBureaus, setAllBureaus] = useState([]);
    const [allYears, setAllYears] = useState([]);
    const selectAgencyRef = useRef(null);
    const selectBureauRef = useRef(null);
    const selectYearRef = useRef(null);
    const [formData, setFormData] = useState({
        agencyName: 'All',
        bureauName: 'All',        
        fiscalYear: 'All',
      });
      let bureauDataSource = null;
    
    useEffect(() => { 
        // getAgencyNames();
        fetchBasicSecurityData(); 
        bureauDataSource = selectBureauRef.current?.instance().getDataSource();
    }, []);

    usePageTitle( title );

    const fetchBasicSecurityData = async () => {
        setLoading(true);
        const data = await GetFetch(`/v1/BasicSecurity/LetterData`);
        const { Success, Message, Errors } = data;
        setError(Success === false);
        if (Success) {
            const agencies = Message.map((props) => { return props.AgencyName });
            const bureaus = Message.map((props) => { return {id: props.AgencyName, name: props.BureauName}});
            const years = Message.map((props) => { return props.FiscalYear });
            const uniqueAgencyNames = ['All', ...new Set(agencies)].sort();
            // const uniqueBureauNames = [{id: 'All', name: 'All'}, ...new Set(bureaus)].sort((a, b) => a.name.localeCompare(b.name));
            const uniqueBureauNames = [{id: 'All', name: 'All'}, ...Array.from(new Map(bureaus.map(obj => [obj.name, obj])).values()).sort((a, b) => a.name.localeCompare(b.name))];
            const uniqueFiscalYears = ['All', ...new Set(years)];
            setAllAgencies(uniqueAgencyNames);
            setAllBureaus(uniqueBureauNames);    
            setAllYears(uniqueFiscalYears);
            setDataSource(Message);
        }
        if (Errors?.length > 0) {
            setErrorMessage(Errors[0].Message)
            console.log(Errors)
        }
        setLoading(false);
    };

    const applyFilter = (e) =>
    {
        const dataGrid = dataGridRef.current.instance();
        const aName = selectAgencyRef.current.instance();
        const bName = selectBureauRef.current.instance();    
        const fYear = selectYearRef.current.instance();
        const bDataSource = selectBureauRef.current?.instance().getDataSource();
        // let bEditor = e.component.getEditor("Bureau");
        // let bDataSource = bEditor.getDataSource();
        
        if (e.element.id === 'agencyName')
            formData.bureauName = 'All';

        // if (e.element.id === 'agencyName' && e.value === 'All')
        //     formData.bureauName = 'All';

        if (e.event !== undefined) {
            formData.agencyName = e.element.id === 'agencyName' ? e.value : formData.agencyName;
            formData.bureauName = e.element.id === 'bureauName' ? e.value : formData.bureauName;            
            formData.fiscalYear = e.element.id === 'fiscalYear' ? e.value : formData.fiscalYear;
            
            if (formData.agencyName === 'All') {
                bDataSource.filter(null);
                bDataSource.load();
            } else {
                bDataSource.filter([["id", "=", 'All'], "or", ["id", "=", formData.agencyName]]);
                bDataSource.load();
            }

            if (formData.agencyName === 'All' && formData.bureauName === 'All' && formData.fiscalYear === 'All') {
                dataGrid.clearFilter();
                selectBureauRef.current.instance().option("value", formData.bureauName);
            }

            if (formData.agencyName !== 'All' && formData.bureauName === 'All' && formData.fiscalYear === 'All') {
                dataGrid.filter(['AgencyName', '=', formData.agencyName]);
                bDataSource.filter([["id", "=", 'All'], "or", ["id", "=", formData.agencyName]]);
                bDataSource.load();
            }
            
            if (formData.agencyName !== 'All' && formData.bureauName !== 'All' && formData.fiscalYear === 'All') {
                dataGrid.filter([['AgencyName', '=', formData.agencyName], "and", ['BureauName', '=', formData.bureauName]]);
                bDataSource.filter([["id", "=", 'All'], "or", ["id", "=", formData.agencyName]]);
                bDataSource.load();
            }
            
            if (formData.agencyName !== 'All' && formData.bureauName === 'All' && formData.fiscalYear !== 'All')
                dataGrid.filter([['AgencyName', '=', formData.agencyName], "and", ['FiscalYear', '=', formData.fiscalYear]]);
            
            if (formData.agencyName === 'All' && formData.bureauName !== 'All' && formData.fiscalYear !== 'All')
                dataGrid.filter([['BureauName', '=', formData.bureauName], "and", ['FiscalYear', '=', formData.fiscalYear]]);
            
            if (formData.agencyName !== 'All' && formData.bureauName !== 'All' && formData.fiscalYear !== 'All') {
                dataGrid.filter([['AgencyName', '=', formData.agencyName], "and", ['BureauName', '=', formData.bureauName], "and", ['FiscalYear', '=', formData.fiscalYear]]);
                bDataSource.filter([["id", "=", 'All'], "or", ["id", "=", formData.agencyName]]);
                bDataSource.load();               
            }

            if (formData.agencyName === 'All' && formData.bureauName !== 'All' && formData.fiscalYear === 'All')
                dataGrid.filter(['BureauName', '=', formData.bureauName]);
 
            if (formData.agencyName === 'All' && formData.bureauName === 'All' && formData.fiscalYear !== 'All')
                dataGrid.filter(['FiscalYear', '=', formData.fiscalYear]);
            setFormData(formData);
        } else {
            aName.clear(formData.agencyName);
            bName.clear(formData.bureauName);
            fYear.clear(formData.fiscalYear);
        }
    };
    
    const handleAssessmentLetterClick = async (e) => {
        var item = e.element.id
        const itemArray = item.split(" ");
        const itemQuery = '?AGBUCode=' + itemArray[0] + '&FiscalYear=' + itemArray[1];
        const itemFile = 'AGBU' + itemArray[0] + 'FY' + itemArray[1] + '.zip';
        console.log(item);

        try {
            const result = await GetFetchZip('/v1/BasicSecurity/DownloadSecurityLetter' + itemQuery, itemFile);
            console.log("BSA Download Result: ", result)
        }
        catch (error) {
            console.error(error)
        }
    };

    const renderAssessmentLetterButton = (e) => {
        var fYear = (e.data.FiscalYear === '' || e.data.FiscalYear === undefined || e.data.FiscalYear === null ) ? '2026' : e.data.FiscalYear;
        var item = e.data.AGBUCode + " " + fYear;
        //var item = '?AGBUCode=' + e.data.AGBUCode + '&FiscalYear=' + fYear;
        console.log(item);

        return <Button 
            id={item}
            icon='floppy' 
            hint="Assessment Letter"
            stylingMode='text' 
            onClick={(e) => handleAssessmentLetterClick(e)}
            />
    }
    const GroupCell = options => <div>{options.caption}</div>;
    const onBackClick = () => {
        navigateToHomePage();
    };

    const handleExport = (e) => {
        logExport(user.email)
        ExportGrid(e, title, true, 12)
    };

    return (
        <>
            <div className="inline__div--wrapper">
                <h1> { title } </h1>
            </div>
            {/*{allowCreate &&
                <Button
                    stylingMode="contained"
                    text="Download All Basic Security Data"
                    width={250}
                    onClick={() => navigate(ROUTE_BASIC_SECURITY_INFORMATION.withSlash)}
                    id="download_basic_security_data"
                />
            } */}
            {loading && !dataSource && <LoadingPanel location={{ of: '#bsa-list' }} message="Loading Basic Security Letter Data..." />}
            {
                dataSource &&
                <div id='bsa-list' className="inline__div--wrapper">
                    <DataGrid 
                        columnAutoWidth={true}
                        dataSource={dataSource}
                        ref={dataGridRef}
                        onCellPrepared={CustomPreparedHeaderCell}
                        onExporting={e => handleExport(e)}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        export={{enabled: true, formats: pageFormats}}
                        key="Id"
                        >
                        <Toolbar>
                            <Item dataField="Agency" location="before" widget="dxSelectBox">
                                <SelectBox
                                    id='agencyName'
                                    ref = {selectAgencyRef}
                                    label='Agency Name'
                                    width="225"
                                    items={allAgencies}
                                    value={formData.agencyName}
                                    onValueChanged={e => applyFilter(e)} />
                            </Item>
                            <Item dataField="Bureau" location="before" widget="dxSelectBox">
                                <SelectBox
                                    id='bureauName'
                                    ref = {selectBureauRef}
                                    label='Bureau Name'
                                    width="225"
                                    dataSource={allBureaus}
                                    displayExpr="name"
                                    valueExpr="name"
                                    value={formData.bureauName}
                                    placeholder='All'
                                    onValueChanged={e => applyFilter(e)} />
                            </Item>                            
                            <Item dataField="FiscalYear" location="before" widget="dxSelectBox">
                                <SelectBox
                                    id='fiscalYear'
                                    ref={selectYearRef}
                                    label='Fiscal Year'
                                    width="225"
                                    items={allYears}
                                    value={formData.fiscalYear}
                                    onValueChanged={e => applyFilter(e)} />
                            </Item>
                            <Item
                                location="after"
                                name="searchPanel"
                                locateInMenu="auto"
                            />
                            <Item
                                location='after'
                                name="exportButton"
                                enabled={true}
                                formats={pageFormats}
                            />
                        </Toolbar>
                        <Column 
                            caption='Agency Name'
                            dataField='AgencyName'
                            groupIndex={0}
                        />
                        <Column 
                            caption='Bureau Name'
                            dataField='BureauName'
                        />
                        <Column 
                            caption='Fiscal Year'
                            dataField='FiscalYear'
                            groupIndex={1}
                        />
                        <Column 
                            caption='AGBU Code'
                            dataField='AGBUCode'
                        />
                            <Column
                                caption='Assessment Amount'
                                dataField='TotalAssessmentAmount'
                                dataType='number'
                                width={150}>
                                <Format
                                    type="currency"
                                    precision={2}
                                />
                            </Column>
                          <Column 
                            dataField="Id"
                            name="Edit" 
                            caption=""
                            hint="Assessment Letter" 
                            width={50} 
                            cellRender={(e) => renderAssessmentLetterButton(e)} 
                        />
                        <Summary>
                            <GroupItem
                                column="TotalAssessmentAmount"
                                summaryType="sum"
                                valueFormat="currency"
                                alignByColumn={true} />
                        </Summary>
                        <KeyboardNavigation enabled={true} />
                        <SearchPanel 
                            highlightCaseSensitive={true}
                            visible={true}
                        />
                        <Pager 
                            allowedPageSizes={allowedPageSizes}
                            showPageSizeSelector={true}
                        />
                        <Paging 
                            defaultPageSize={10}
                        />
                    </DataGrid>
                </div>
            }
        </>
    )
};

export default BasicSecurityData;